/**
 * 指定文字列の先頭または末尾にある以下の文字を削除します（複数あっても）。
 *
 * * 半角スペース
 * * 全角スペース
 *
 * @param {String} value トリム対象文字列
 */
export function trimAll(value) {
  // eslint-disable-next-line no-irregular-whitespace
  return value.replace(/^[\s|　]+|[\s|　]+$/g, '')
}

/**
 * Base64エンコードします
 *
 * @param {String} str エンコードする文字列
 */
export function toBase64(str) {
  const encoder = new TextEncoder()
  const bytes = encoder.encode(str)

  // Uint8Array -> binary string
  let binary = ''
  for (let i = 0; i < bytes.length; i++) {
    binary += String.fromCharCode(bytes[i])
  }

  // binary string -> Base64
  return btoa(binary)
}

/**
 * Base64デコードします
 *
 * @param {String} base64Str デコードするBase64文字列
 */
export function fromBase64(base64Str) {
  // Base64 -> binary string
  const binary = atob(base64Str)

  // binary string -> Uint8Array
  const length = binary.length
  const bytes = new Uint8Array(length)
  for (let i = 0; i < length; i++) {
    bytes[i] = binary.charCodeAt(i)
  }

  const decoder = new TextDecoder('utf-8')
  return decoder.decode(bytes)
}
